import { render, staticRenderFns } from "./examinationManage.vue?vue&type=template&id=535538e6&"
import script from "./examinationManage.vue?vue&type=script&lang=js&"
export * from "./examinationManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports